import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.common)

export const COMMON_INSTANCE = service.instanceKey

export const COMMON_ENDPOINTS = {
  GET_CURRENCIES: "/commonutils/getcurrencies",
  GET_COUNTRIES: "/commonutils/getcountries",
  GET_ACTIVATED_COUNTRIES: "/commonutils/getactivatedcountries",
  GET_STATES: "/commonutils/getstates",
  GET_STATES_BY_COUNTRY: "/commonutils/getstatesbycountrycode",
  GET_BANKS: "/commonutils/getbanks",
  GET_BANKS_BY_COUNTRY: "/commonutils/getbanksbycountrycode",
  GET_EMPLOYMENT_STATUS: "/commonutils/getemploymentstatus",
  GET_EMPLOYEE_TYPES: "/commonutils/getemployeetypes",
  GET_EMPLOYEE_TITLES: "/commonutils/getemployeetitles",
  GET_PAYMENT_METHODS: "/commonutils/getpaymentmethods",
  GET_PAY_GRADES: "/commonutils/getpaygrades",
  GET_PAY_BANDS: "/commonutils/getpaybands",
  GET_EMPLOYEE_SCOPES: "/commonutils/getemployeescopes",
  GET_PERSON_CUSTOM_INFO: "/commonutils/getpersoncustominfo",
  GET_EMPLOYEE_REQUEST_TYPES: "/commonutils/getemployeerequesttypes",
  GET_ACTIVITY_MONITOR: "/commonutils/getactivitymonitor",
  GET_COUNTRIES_BY_CURRENCY: "/commonutils/getcountriesbycurrencycode",
  GET_BIRTHDAY_DAY: "/commonutils/getbirthdayday",
  GET_BIRTHDAY_MONTH: "/commonutils/getbirthdaymonth",
  GET_BIRTHDAY_YEAR: "/commonutils/getbirthdayyear",
  GET_WALLET_PRODUCTS: "/commonutils/getwalletproducts",
  GET_SMART_TEXTS: "/commonutils/getsmarttexts",
} as const

export const commonService = {
  instanceKey: service.instanceKey,

  getCountries: () => service.get(COMMON_ENDPOINTS.GET_COUNTRIES),
  getActivatedCountries: () =>
    service.get(COMMON_ENDPOINTS.GET_ACTIVATED_COUNTRIES),
  getStates: () => service.get(COMMON_ENDPOINTS.GET_STATES),
  getStatesByCountry: (countryCode: string) =>
    service.get(`${COMMON_ENDPOINTS.GET_STATES_BY_COUNTRY}?id=${countryCode}`),
  getBanks: () => service.get(COMMON_ENDPOINTS.GET_BANKS),
  getBanksByCountry: (countryCode: string) =>
    service.get(`${COMMON_ENDPOINTS.GET_BANKS_BY_COUNTRY}?id=${countryCode}`),
  getEmploymentStatus: () =>
    service.get(COMMON_ENDPOINTS.GET_EMPLOYMENT_STATUS),
  getEmployeeTypes: () => service.get(COMMON_ENDPOINTS.GET_EMPLOYEE_TYPES),
  getEmployeeTitles: () => service.get(COMMON_ENDPOINTS.GET_EMPLOYEE_TITLES),
  getPaymentMethods: () => service.get(COMMON_ENDPOINTS.GET_PAYMENT_METHODS),
  getPayGrades: () => service.get(COMMON_ENDPOINTS.GET_PAY_GRADES),
  getPayBands: () => service.get(COMMON_ENDPOINTS.GET_PAY_BANDS),
  getEmployeeScopes: () => service.get(COMMON_ENDPOINTS.GET_EMPLOYEE_SCOPES),
  getPersonCustomInfo: () =>
    service.get(COMMON_ENDPOINTS.GET_PERSON_CUSTOM_INFO),
  getEmployeeRequestTypes: () =>
    service.get(COMMON_ENDPOINTS.GET_EMPLOYEE_REQUEST_TYPES),
  getActivityMonitor: (payrollId: string | number) =>
    service.get(`${COMMON_ENDPOINTS.GET_ACTIVITY_MONITOR}?id=${payrollId}`),
  getCountriesByCurrency: (code: string) =>
    service.get(`${COMMON_ENDPOINTS.GET_COUNTRIES_BY_CURRENCY}?code=${code}`),
  getBirthdayDay: () => service.get(COMMON_ENDPOINTS.GET_BIRTHDAY_DAY),
  getBirthdayMonth: () => service.get(COMMON_ENDPOINTS.GET_BIRTHDAY_MONTH),
  getBirthdayYear: () => service.get(COMMON_ENDPOINTS.GET_BIRTHDAY_YEAR),
  getWalletProducts: (isCollection = false) =>
    service.get(
      `${COMMON_ENDPOINTS.GET_WALLET_PRODUCTS}?is_collection=${isCollection}`
    ),
  getCurrencies: (params?: { forpayment: boolean }) =>
    service.get(COMMON_ENDPOINTS.GET_CURRENCIES, {
      forpayment: params?.forpayment,
    }),
  getCompanySetupInfo: () => service.get(`/account/getcompanysetupinfo`),
  getPaygrades: () => service.get(COMMON_ENDPOINTS.GET_PAY_GRADES),
  getPaybands: () => service.get(COMMON_ENDPOINTS.GET_PAY_BANDS),
  selectPfa: () => service.get(`/control/statutory/select_pfa`),
  // New-arch GetSmartTexts filters by `type` (Request | Hiring | Anniversary);
  // omitting it returns the offer-letter smart texts.
  getSmartTexts: (forRequest = false, forHiring = false) =>
    service.get(COMMON_ENDPOINTS.GET_SMART_TEXTS, {
      type: forRequest ? "Request" : forHiring ? "Hiring" : undefined,
    }),
}
